import { Article } from '../models/article.model';
import { HttpErrorResponse } from '@angular/common/http';
import { Posting } from 'app/library/posting/models/posting.model';
import { IFetchEntityFailureActionPayload } from 'app/projects/entity/src/lib/interfaces/fetch-entity-failure-payload.interface';
import { ICreateEntityFailureActionPayload } from 'app/projects/entity/src/lib/interfaces/create-entity-failure-payload.interface';
import { IUpdateEntityFailureActionPayload } from 'app/projects/entity/src/lib/interfaces/update-entity-failure-payload.interface';
import { GlobalParticipant } from 'app/projects/user/src/lib/models/participant.model';

export class SetArticle {
    static readonly type = '[Article] SetArticle';

    constructor(public payload) {}
}

export class UnsetArticle {
    static readonly type = '[Article] UnsetArticle';

    constructor(public payload) {}
}

export class FetchArticle {
    static readonly type = '[Article] FetchArticle';

    constructor(public payload: string) {}
}

export class FetchArticleSuccess {
    static readonly type = '[Article] FetchArticleSuccess';

    constructor(public payload: Article) {}
}

export class FetchArticleFailure {
    static readonly type = '[Article] FetchArticleFailure';

    constructor(public payload: IFetchEntityFailureActionPayload) {}
}

export class FetchArticleByUniqueId {
    static readonly type = '[Article] FetchArticleByUniqueId';

    constructor(public payload: string) {}
}

export class FetchArticleByUniqueIdSuccess {
    static readonly type = '[Article] FetchArticleByUniqueIdSuccess';

    constructor(public payload: Article) {}
}

export class FetchArticleByUniqueIdFailure {
    static readonly type = '[Article] FetchArticleByUniqueIdFailure';

    constructor(public payload: HttpErrorResponse) {}
}

export class CreateArticle {
    static readonly type = '[Article] CreateArticle';

    constructor(public payload: Article) {}
}

export class CreateArticleSuccess {
    static readonly type = '[Article] CreateArticleSuccess';

    constructor(public payload: Article) {}
}

export class CreateArticleFailure {
    static readonly type = '[Article] CreateArticleFailure';

    constructor(public payload: ICreateEntityFailureActionPayload) {}
}

export class UpdateArticle {
    static readonly type = '[Article] UpdateArticle';

    constructor(public payload: Article) {}
}

export class UpdateArticleSuccess {
    static readonly type = '[Article] UpdateArticleSuccess';

    constructor(public payload: Article) {}
}

export class UpdateArticleFailure {
    static readonly type = '[Article] UpdateArticleFailure';

    constructor(public payload: IUpdateEntityFailureActionPayload) {}
}

export class UpdateArticleRelatedPostings {
    static readonly type = '[Article] UpdateArticleRelatedPostings';

    constructor(public payload: { articleId: string; postings: Posting[] }) {}
}

export class UpdateArticleRelatedPostingsSuccess {
    static readonly type = '[Article] UpdateArticleRelatedPostingsSuccess';

    constructor(public payload: Article) {}
}

export class UpdateArticleRelatedPostingsFailure {
    static readonly type = '[Article] UpdateArticleRelatedPostingsFailure';

    constructor(public payload: HttpErrorResponse) {}
}

export class DeleteArticle {
    static readonly type = '[Article] DeleteArticle';

    constructor(public payload: string) {}
}

export class DeleteArticleSuccess {
    static readonly type = '[Article] DeleteArticleSuccess';

    constructor(public payload: string) {}
}

export class DeleteArticleFailure {
    static readonly type = '[Article] DeleteArticleFailure';

    constructor(
        public payload: {
            response: HttpErrorResponse;
        }
    ) {}
}

export class SetArticles {
    static readonly type = '[Article] SetArticles';

    constructor(public payload: Article[]) {}
}

export class SetSortBySelected {
    static readonly type = '[Article] SetSortBySelected';

    constructor(public payload: string) {}
}

export class SetSortOrderSelected {
    static readonly type = '[Article] SetSortOrderSelected';

    constructor(public payload: string) {}
}

export class AddArticles {
    static readonly type = '[Article] AddArticles';

    constructor(public payload: Article[]) {}
}

export class FetchArticles {
    static readonly type = '[Article] FetchArticles';
}

export class FetchArticlesSuccess {
    static readonly type = '[Article] FetchArticlesSuccess';
}

export class FetchArticlesFailure {
    static readonly type = '[Article] FetchArticlesFailure';
}

export class FetchArticlesAuthors {
    static readonly type = '[Article] FetchArticlesAuthors';
}

export class FetchArticlesAuthorsSuccess {
    static readonly type = '[Article] FetchArticlesAuthorsSuccess';

    constructor(public payload: GlobalParticipant[]) {}
}

export class FetchArticlesAuthorsFailure {
    static readonly type = '[Article] FetchArticlesAuthorsFailure';
}
